import React, { useRef } from "react";
import _ from "lodash";
import cx from "classnames";
import { Icon, Tooltip } from "@showitinc/showit-wc";
import Tooltips from "../constants/HelpTooltips";

function HelpTooltip(props) {
  const buttonRef = useRef(null);
  const { baseClassName, className, tooltipKey, placement, look, children } = props;
  const tooltipText = _.get(Tooltips, [tooltipKey, "t"], "");

  let lookClass = null;

  if (look) {
    lookClass = `${baseClassName}--${look}`;
  }

  return (
    <div className={cx(baseClassName, lookClass, className)}>
      <Tooltip position={placement}>
        <span slot="content">
          <div dangerouslySetInnerHTML={{ __html: tooltipText }} />
        </span>
        {children ? (
          <div ref={buttonRef}>{children}</div>
        ) : (
          <Icon type="helpResources" size="20" ref={buttonRef} />
        )}
      </Tooltip>
    </div>
  );
}

HelpTooltip.defaultProps = {
  baseClassName: "si-c-help-tooltip",
  placement: "top-left",
  trigger: "click",
};

export default HelpTooltip;
